<div class="container-top">
  <div class="container-button">
    <span nzTooltipPlacement="top" nz-tooltip nzTooltipTitle="Ajukan izin">
      <a class="btn btn-lg btn-light mr-2" (click)="addLeave()">
        <i class="fe fe-plus-circle"></i>
      </a>
    </span>
    <!-- <span nzTooltipPlacement="top" nz-tooltip nzTooltipTitle="Refresh">
      <a class="btn btn-lg btn-light mr-2" (click)="reset()">
        <i class="fe fe-refresh-cw"></i>
      </a>
    </span> -->

    <!-- <nz-select
      nzPlaceHolder="Filter tipe izin"
      nzShowSearch
      [(ngModel)]="selectedType"
      style="height: 44px !important; padding-top: 4px !important; padding-bottom: 2px;"
      (ngModelChange)="filterType($event)"
    >
      <nz-option *ngFor="let item of listPermitType" [nzLabel]="item.label" [nzValue]="item.label">
        {{ item.label }}
      </nz-option>
    </nz-select> -->
  </div>

  <div class="container-leave-quota">
    <button
      nz-button
      nzType="ghost"
      nzSize="large"
      style="background-color: #E4E9F0 !important; font-weight: 600 !important; color: black !important;"
    >
      Izin Khusus =
      <span style="margin-left: 8px; color: red;">
        {{ annualSpecialPermit }}
      </span>
    </button>
  </div>

  <div class="container-filter">
    <!-- <nz-select
      nzPlaceHolder="Status"
      nzShowSearch
      [(ngModel)]="selectedStatus"
      style="width: 150px; height: 44px !important; padding-top: 4px !important; padding-bottom: 2px;"
    >
      <nz-option *ngFor="let item of filterStatus" [nzLabel]="item.label" [nzValue]="item.label">
        {{ item.label }}
      </nz-option>
    </nz-select> -->

    <nz-select
      nzPlaceHolder="Pilih file SPT"
      nzShowSearch
      [(ngModel)]="selectedSPTFile"
      style="margin-left: 10px; width: 150px; height: 44px !important; padding-top: 4px !important; padding-bottom: 2px;"
    >
      <nz-option *ngFor="let item of SPTSelectValue" [nzLabel]="item.label" [nzValue]="item.value">
        {{ item.label }}
      </nz-option>
    </nz-select>

    <button
      nz-button
      [nzSize]="'large'"
      nzType="default"
      style="margin-left: 10px;"
      (click)="downloadSPTFile()"
      [disabled]="!selectedSPTFile"
    >
      <span nz-icon nzType="download" nzTheme="outline"></span> Download SPT
    </button>
  </div>
</div>

<div>
  <nz-tabset>
    <nz-tab nzTitle="Menunggu">
      <ng-template nz-tab nzDestroyInactiveTabPane>
        <app-tab-waiting-permit-request
          [selectedType]="selectedType"
        ></app-tab-waiting-permit-request>
      </ng-template>
    </nz-tab>
    <nz-tab nzTitle="Diterima">
      <ng-template nz-tab nzDestroyInactiveTabPane>
        <app-tab-approved-permit-request></app-tab-approved-permit-request>
      </ng-template>
    </nz-tab>
    <nz-tab nzTitle="Canceled">
      <ng-template nz-tab nzDestroyInactiveTabPane>
        <app-tab-cancelled-permit-request></app-tab-cancelled-permit-request>
      </ng-template>
    </nz-tab>
  </nz-tabset>
</div>
